﻿import Chart from 'chart.js/auto'
let bdoGraphPageModel;
let myLineChart = null;

function BDOGraphPageModel() {
    const self = this;
    self.data = null;

    self.setGraphData = function (data) {
        self.data = data;
    }

    self.getGraphDatas = function () {
        const result = {labels: [], datasets: []};
        result.datasets.push({data: []});

        const data = self.data;
        for (let i = data.labels.length - 1; i >= 0; i--) {
            const label = data.labels[i];
            const datasetData = data.datasets[0].data[i];
            result.datasets[0].data.push(datasetData);
            result.datasets[0].fillColor = 'rgba(220,220,220,0)';
            result.datasets[0].strokeColor = data.datasets[0].pointColor;
            result.datasets[0].pointColor = data.datasets[0].pointColor;
            result.datasets[0].pointStrokeColor = data.datasets[0].pointStrokeColor;
            result.datasets[0].pointHighlightFill = data.datasets[0].pointHighlightFill;
            result.datasets[0].pointHighlightStroke = data.datasets[0].pointHighlightStroke;
            result.labels.push(label);
        }
        result.labels.reverse();
        result.datasets[0].data.reverse();
        result.datasets.push({data: []});

        return result;
    }

    self.getData = function () {
        return self.data;
    }
}

function drawLineChart() {
    if (myLineChart) {
        myLineChart.destroy();
    }

    const scaleLabel = "<%=value/1%>";
    const currentMetric = $('[data-graph-type]').data('graph-type');

    const options = {
        responsive: true,
        plugins:{
            legend: {
                display: false
            },
        },
        scaleLabel: scaleLabel

    };
    if (currentMetric === "AverageBaseSalaryForAllPositions") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 20000;
        options.scaleStartValue = 0;
    }
    if (currentMetric === "AverageCommission") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 5000;
        options.scaleStartValue = 0;
    }
    if (currentMetric === "ManagingDirector") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 50000;
        options.scaleStartValue = 100000;
    }
    if (currentMetric === "FinanceDirector") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 15000;
        options.scaleStartValue = 100000;
    }
    if (currentMetric === "DealerPrincipal") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 10000;
        options.scaleStartValue = 70000;
    }
    if (currentMetric === "AverageSalaryExcludingKeyExecutives") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 10000;
        options.scaleStartValue = 0;
    }
    if (currentMetric === "Vehicles") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 10000;
        options.scaleStartValue = 30000;
    }
    if (currentMetric === "Parts") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 10000;
        options.scaleStartValue = 10000;
    }
    if (currentMetric === "Service") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 10000;
        options.scaleStartValue = 10000;
    }
    if (currentMetric === "Administration") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 10000;
        options.scaleStartValue = 10000;
    }
    if (currentMetric === "AverageDealershipAllStaffTurnover") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 2;
        options.scaleStartValue = 0;
    }
    if (currentMetric === "AverageNumberOfHoursWorkedPerDealershipEmployeePerWeek") {
        options.scaleOverride = true;
        options.scaleSteps = 5,
            options.scaleStepWidth = 5;
        options.scaleStartValue = 30;
    }
    const data = bdoGraphPageModel.getGraphDatas();
    const canvas = $("#myChart").get(0);
    const ctx = canvas.getContext("2d");
    const config = {
        type: 'line',
        options: options,
        data
    };
    myLineChart = new Chart(ctx, config);
}

export function setupBDOGraphPage() {
    const page = $('[data-bdo-graph-page]').length;
    if (!page) {
        return;
    }
    bdoGraphPageModel = new BDOGraphPageModel();
    const bdoData = $.parseJSON($('#BDOData').val());
    bdoGraphPageModel.setGraphData(bdoData);

    drawLineChart();

    $(document).on("change", "#OtherMetricPage", function () {
        const selectedMetricPage = $(this).val();
        window.location.href = selectedMetricPage;
    });
}